<mat-sidenav-container>
  @if (isLoggedIn()) {
    <mat-sidenav
      #sidenav
      class="mat-elevation-z4"
      [disableClose]="!mobileNav()"
      [opened]="navOpen()"
      (closed)="closeSideNav()"
      [mode]="mobileNav() === true ? 'over' : 'side'"
    >
      <mat-toolbar class="logo-toolbar">
        <img
          class="main-logo"
          routerLink="."
          (click)="reload()"
          src="static/assets/images/glitchtip-logo-v1.svg"
          alt="GlitchTip"
        />
      </mat-toolbar>
      @for (org of organizations(); track org.id) {}
      @if (contextLoaded() && organizations().length === 0 && canCreateOrg()) {
        <div class="org-create-button-container">
          <a
            matButton="outlined"
            id="create-new-link"
            routerLink="/organizations/new"
            class="org-create-button"
            i18n
            >Create Organization<mat-icon iconPositionEnd>add</mat-icon></a
          >
        </div>
      } @else {
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="org-dropdown-container"
        >
          <mat-select
            #orgSelect
            data-cy="orgSelect"
            [value]="activeOrganizationSlug()"
            formControlName="orgSelectControl"
            (selectionChange)="onOrgSelectChange($event, orgSelect)"
            hideSingleSelectionIndicator
            canSelectNullableOptions
          >
            @for (
              organization of organizations();
              track organization.id;
              let last = $last
            ) {
              <mat-option [value]="organization.slug">
                {{ organization.name }}
              </mat-option>
              @if (last) {
                <mat-divider class="dropdown-divider"></mat-divider>
              }
            }
            @if (canCreateOrg()) {
              <mat-option data-cy="createNewLink" i18n
                >Create organization</mat-option
              >
            } @else {
              <mat-option
                disabled
                matTooltip="Organization creation is currently disabled"
                matTooltipPosition="below"
              >
                Create organization
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-nav-list>
        <mat-tree
          #tree
          [dataSource]="menuData()"
          [childrenAccessor]="childrenAccessor"
        >
          <!-- Default template for navigable items -->
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
            @if (activeOrganization() || !node.requiresActiveOrg) {
              <a
                mat-list-item
                [routerLink]="getRouteWithOrgSlug(node.route)"
                routerLinkActive
                [routerLinkActiveOptions]="{
                  exact: node.useExactRoute ?? false,
                }"
                #issuesLink="routerLinkActive"
                [activated]="issuesLink.isActive"
                >{{ node.name }}</a
              >
            } @else {
              <mat-list-item disabled>
                {{ node.name }}
              </mat-list-item>
            }
          </mat-tree-node>

          <!-- Template for expandable nav nodes -->
          <mat-tree-node
            isExpandable
            *matTreeNodeDef="let node; when: hasChild"
            matTreeNodePadding
            [isDisabled]="!activeOrganization() && node.requiresActiveOrg"
            [cdkTreeNodeTypeaheadLabel]="node.name"
          >
            <mat-list-item
              matTreeNodeToggle
              [disabled]="!activeOrganization() && node.requiresActiveOrg"
            >
              <span matListItemTitle>{{ node.name }}</span>
              <div matListItemMeta>
                <mat-icon>
                  {{
                    tree.isExpanded(node) ? "arrow_drop_down" : "arrow_right"
                  }}
                </mat-icon>
              </div>
            </mat-list-item>
          </mat-tree-node>
        </mat-tree>
        <a mat-list-item (click)="this.logout()" i18n>Log Out</a>
      </mat-nav-list>
      @if (paidForGlitchTip() === false) {
        <mat-divider class="support-cta-divider"></mat-divider>
        <div class="support-cta-container">
          <div class="body-text-strong" il8n>Support GlitchTip</div>
          <ul class="support-cta-list body-text">
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://liberapay.com/GlitchTip/donate"
                il8n
                >Donate
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener"
                href="https://app.glitchtip.com/register?utm_medium=website&utm_source=glitchtip&utm_campaign=selfhost_nagware"
                il8n
                >Switch to hosted</a
              >
            </li>
            <li>
              <a
                href="mailto:sales@glitchtip.com?subject=Purchase support inquiry"
                il8n
                >Purchase support</a
              >
            </li>
          </ul>
        </div>
      }
      <div class="caption-text version">
        <a [routerLink]="['/system-info']" routerLinkActive="active-route" i18n
          >GlitchTip {{ version() }}</a
        >
      </div>
    </mat-sidenav>
  }

  <mat-sidenav-content>
    @if (isLoggedIn()) {
      <gt-mobile-nav-toolbar
        [activeOrg]="activeOrganization()"
        (buttonClicked)="toggleSideNav()"
      ></gt-mobile-nav-toolbar>
    }
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
